import request from '../utils/request.util'

export default {
  getList (params) {
    return request.get('/purchases', { params })
  },
  getTotal (params) {
    return request.get('/purchases/total', { params })
  },
  getSummary (params) {
    return request.get('/purchases/summary', { params })
  },
  getReport (params) {
    return request.get('/purchases/reports', { params })
  },
  remove (id) {
    return request.delete(`/purchases/${id}`)
  }
}
